import { Tab, TabProps } from '@chakra-ui/react'
import React from 'react'

export interface TabWithCountProps extends TabProps {
  count: number
}

export const TabWithCount = ({
  children,
  count,
  ...props
}: TabWithCountProps) => {
  return (
    <Tab fontWeight="normal" isDisabled={count === 0} {...props}>
      {children}
      {<>&nbsp;-&nbsp;{count}</>}
    </Tab>
  )
}
